<template>
  <div>
    <van-tabs v-model="active" class="tabs" :swipeable="true">
      <van-tab v-for="(item, index) in tabList" :key="index" :title="item.label">
        <div class="content">
          <ul class="list" v-for="(item, index) in list" :key="index" @click="activeClick(item)">
            <li class="item_img">
              <img :src="require('../../assets/message/' + active + '.png')">
            </li>
            <li class="item_content">
              <div class="item_title">
                <div class="title_text">{{ item.title }}</div>
                <div class="title_time">
                  {{ item.time }}
                </div>
              </div>
              <div class="item_desc">
                {{ item.content }}
              </div>
            </li>
          </ul>
        </div>
      </van-tab>
    </van-tabs>

  </div>
</template>
<script>
import listJson from "./message.json"
export default {
  data() {
    return {
      active: 0,
      tabList: [
        {
          label: "预警信息",
        },
        {
          label: "报告信息",
        }, {
          label: "活动信息",
        }, {
          label: "产品发布",
        }, {
          label: "系统升级",
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.active = this.$route.query.active ? Number(this.$route.query.active) : 0

    });
  },
  computed: {
    list() {
      let list = listJson.filter(item => item.type == this.active + 1)
      return list
    }
  },
  methods: {
    activeClick(item) {
      console.log(item);
      //  1代表预警信息 2代表 报告信息 3代表活动信息 4代表产品发布 5代表系统升级
      switch (item.type) {
        case '1':
          this.$router.push({ path: '/warning', query: { id: item.id } })
          break;
        case '2':
          this.$router.push({ path: '/report', query: { id: item.id } })
          break;
        case '3':
          this.$router.push({ path: '/events', query: { id: item.id } })
          break;
        case '4':
          this.$router.push({ path: '/publish', query: { id: item.id } })
          break;
        case '5':
          this.$router.push({ path: '/system', query: { id: item.id } })
          break;
        default:
          break;
      }
    }
  },
}
</script>
<style lang="less" scoped>
.tabs {
  border-bottom: 1px solid #eee;
}

.content {
  width: 80%;
  min-height: 90vh;
  margin: 0 auto;

  .list {
    display: flex;
    margin-top: 15px;
    border-radius: 5px;
    padding: 10px;
    // 边框阴影
    box-shadow: 0px 3px 6px #ccc;

    .item_img {
      width: 20%;

      img {
        width: 80%;
      }
    }

    .item_content {
      margin-top: 15px;
      width: 80%;

      .item_title {
        display: flex;
        justify-content: space-between;

        .title_text {
          font-size: 0.16rem;
          font-weight: bold;
          width: 60%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .title_time {
          font-size: 0.14rem;
        }
      }

      .item_desc {
        margin-top: 10px;
        font-size: 0.14rem;
        // 文字超出显示。。。
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
</style>